import { createRoot } from 'react-dom/client';

import App from './App';

let currentLink = document.currentScript?.getAttribute('src');
currentLink = currentLink?.slice(0, currentLink.length - 9);

const head = document.getElementsByTagName('body')[0];

const link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
link.href = `${currentLink}style.css`;
link.media = 'all';
head.appendChild(link);

window.addEventListener('load', () => {
  const container = document.getElementById('dunning-container') as HTMLElement;
  createRoot(container).render(<App />);
});
